import { makeStyles, createStyles } from '@material-ui/core'
import {
  autoCompleteStyles
} from '../../TransactionsMonitoring/components/Filters/components/common_styles';

export const listsTableCellStyles = {
  fontFamily: 'Roboto-Regular',
  color: '#202A38',
  backgroundColor: 'white',
  verticalAlign: 'middle',
};

export const scrollStyles = {
  /* width */
  '&::-webkit-scrollbar': {
    width: 8,
    height: 8,
  },

  /* Track */
  '&::-webkit-scrollbar-track': {
    background: '#f1f1f1'
  },

  /* Handle */
  '&::-webkit-scrollbar-thumb': {
    background: '#ADB6BD',
    borderRadius: 5
  },

  /* Handle on hover */
  '&::-webkit-scrollbar-thumb:hover': {
    background: '#9ba2a8'
  }
};


export const listPageStyles = {
  pageContainer: {
    display: 'flex !important',
    flexDirection: 'column',
    height: (props) => props.viewOnly ? 'auto' : 'calc(100svh - 72px - 24px)', // 72px header and 24px padding from page container
  },
  container: {
    // class for table container
    flexGrow: 1,
    overflow: 'auto',
    minHeight: 150,
    maxHeight: 'fit-content',
    ...scrollStyles,
  },
  paginationContainer: {
    paddingTop: 8,
  },
  tableHead: {
    position: 'sticky',
    top: 0,
    zIndex: 1,

    '& td': {
      fontFamily: 'Roboto-Bold',
      color: '#80858C',
      backgroundColor: '#eef0f2',
      verticalAlign: 'top'
    }
  },
};

export const styles = (theme, props) => createStyles({
  header: {
    fontFamily: 'Roboto-Bold',
    fontSize: 34,
    color: '#202A38',
    margin: 0
  },
  ...listPageStyles,

  tableCell: {
    '&:first-child': {
      width: 30
    },

    '&.name': {
      width: (props) => props.nameCellWidth || 300
    },

    '&:last-child': {
      width: (props) => props.actionTableCellWidth || (props.viewOnly ? 95 : 200)
    },

    ...listsTableCellStyles
  },

  navigationContainer: {
    display: 'flex',
    justifyContent: 'space-between',

    '& button >span > span': {
      fontSize: 14
    }
  },
  autocompleteInput: autoCompleteStyles,
  menuItem: {
    fontFamily: 'Roboto-Regular',
    fontSize: 16,
    color: '#202A38',
    backgroundColor: 'white !important',
    width: '100%',
    paddingLeft: 17,
    paddingRight: 17,

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.04) !important',
    },

    '& .MuiListItemText-root span': {
      fontFamily: 'Roboto-Regular',
      fontSize: 16,
      color: '#202A38',
    },
  },
});

export default makeStyles(styles)